import './promise-polyfill'
import { app } from './app'

// Without a timeout, jquery can cause a race condition where it moves the element
// in the exact same frame where the application initializes. This will result in
// 2 application instances.
setTimeout(() => {
  app.$mount('#wsc_shop_app')
}, 2)



// WEBPACK FOOTER //
// ./client/index.js